import { useContext, useMemo } from 'react'
import { CartItem as CartItemType } from '../../../domain/cart'
import CartItemCarving from './CartItemCarving'
import getIsItemStillValidOnCart from '../CheckoutWorkflow/getIsItemStillValidOnCart'
import useUpdateCarvingOfCartItem from '../../../core/hook/cartHooks/useUpdateCarvingOfCartItem'
import { ConfigContext } from '../../context/ConfigContext'
import useCurrentLocale from '../../../core/hook/useCurrentLocale'
import { formatPriceByStoreAndLocale } from '../../utils/price.utils'
import FormattedPrice from '../FormattedPrice/FormattedPrice'

const CartItemSimpleProduct = ({
  item,
  onUpdate,
}: {
  item: CartItemType
  onUpdate: (updating: boolean) => void
}) => {
  const updateCarving = useUpdateCarvingOfCartItem()

  const isItemStillValidOnCart = useMemo(() => getIsItemStillValidOnCart(item), [item])

  // Change Carving on Simple Product
  const onChangeCarving = (carving?: Carving) => {
    onUpdate(true)
    updateCarving(item, carving).then(() => onUpdate(false))
  }

  if (!isItemStillValidOnCart) {
    return null
  }

  const { storeConfig } = useContext(ConfigContext)
  const currentLocale = useCurrentLocale()
  const formatedPrice = formatPriceByStoreAndLocale(currentLocale, item.prices ?? undefined)

  return (
    <>
      {storeConfig.display_prices === 1 && (
        <p className='price mt-9'>
          <FormattedPrice price={formatedPrice.value} currency={formatedPrice.currency} />
        </p>
      )}
      <CartItemCarving item={item} onChange={onChangeCarving} />
    </>
  )
}

export default CartItemSimpleProduct
